import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStopCircleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM14 8C15.0544 8 15.9182 8.81588 15.9945 9.85074L16 10V14C16 15.0544 15.1841 15.9182 14.1493 15.9945L14 16H10C8.94564 16 8.08183 15.1841 8.00549 14.1493L8 14V10C8 8.94564 8.81588 8.08183 9.85074 8.00549L10 8H14ZM14 10H10V14H14V10Z",
		fill: "currentColor"
	})
});
export default SvgStopCircleLine;
